export default "__VITE_ASSET__CNFyLXQW__"